import Vue from 'vue'
import Router from 'vue-router'
// 导航栏
import nav from '../components/nav.vue'
// 首页
import home from '../components/content/home.vue'
// 产品中心
import iiot from '../components/product/IIoT.vue'
import wms from '../components/product/wms.vue'
import mes from '../components/product/mes.vue'
import npm from '../components/product/npm.vue'
import npi from '../components/product/npi.vue'
// 客户案列
import customer from '../components/customer-case/customer.vue'
import haoen from '../components/customer-case/haoen.vue'
import jinghua from '../components/customer-case/jinghua.vue'
import lixun from '../components/customer-case/lixun.vue'
import hangsheng from '../components/customer-case/hangsheng.vue'
import zechen from '../components/customer-case/zechen.vue'
import hengtianweiyan from '../components/customer-case/hengtianweiyan.vue'
import shennandianlu from '../components/customer-case/shennandianlu.vue'
import sanjiang from '../components/customer-case/sanjiang.vue'
import nanruijibao from '../components/customer-case/nanruijibao.vue'
import huayang from '../components/customer-case/huayang.vue'
import zhuoao from '../components/customer-case/zhuoao.vue'
import changcheng from '../components/customer-case/changcheng.vue'
import huarong from '../components/customer-case/huarong.vue'
import kangyuan from '../components/customer-case/kangyuan.vue'
import weixin from '../components/customer-case/weixin.vue'
import hainengda from '../components/customer-case/hainengda.vue'
// 公司介绍
import company from '../components/content/company.vue'
// 人才招聘
import talent from '../components/content/talent.vue'
// 联系我们
import contact from '../components/content/contact.vue'
// 公司新闻
import news from '../components/content/news.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/nav',
            component: nav,
            children: [
                {
                    path: '/home',
                    component: home
                },
                {
                    path: '/iiot',
                    component: iiot
                },
                {
                    path: '/wms',
                    component: wms
                },
                {
                    path: '/mes',
                    component: mes
                },
                {
                    path: '/npm',
                    component: npm
                },
                {
                    path: '/npi',
                    component: npi
                },
                {
                    path: '/customer',
                    component: customer
                },
                {
                    path: '/haoen',
                    component: haoen
                },
                {
                    path: '/jinghua',
                    component: jinghua
                },
                {
                    path: '/lixun',
                    component: lixun
                },
                {
                    path: '/hangsheng',
                    component: hangsheng
                },
                {
                    path: '/zechen',
                    component: zechen
                },
                {
                    path: '/hengtianweiyan',
                    component: hengtianweiyan
                },
                {
                    path: '/shennandianlu',
                    component: shennandianlu
                },
                {
                    path: '/sanjiang',
                    component: sanjiang
                },
                {
                    path: '/nanruijibao',
                    component: nanruijibao
                },
                {
                    path: '/huayang',
                    component: huayang
                },
                {
                    path: '/zhuoao',
                    component: zhuoao
                },
                {
                    path: '/changcheng',
                    component: changcheng
                },
                {
                    path: '/huarong',
                    component: huarong
                },
                {
                    path: '/kangyuan',
                    component: kangyuan
                },
                {
                    path: '/weixin',
                    component: weixin
                },
                {
                    path: '/hainengda',
                    component: hainengda
                },
                {
                    path: '/company',
                    component: company
                },
                {
                    path: '/talent',
                    component: talent
                },
                {
                    path: '/contact',
                    component: contact
                },
                {
                    path: '/news',
                    component: news
                },
            ]
        },

    ]
})
